// extracted by mini-css-extract-plugin
export default {"modalOverlay":"RD-z","modalContent":"SD-z","header":"TD-z","close":"UD-z"};